import {connect} from 'react-redux';

import {TableColumn} from '../../../../../../../../../src/components/common/table/tableColumn';
import {TableRowRenderOptions} from '../../../../../../../../../src/components/common/table/tableRow';
import {AppState} from '../../../../../../../../../src/store/appState';
import {getCardGroups} from '../../../../../../../../../src/store/data/dataSelectors';
import {
  createSelector,
  makeMapStateToProps,
} from '../../../../../../../../../srcCommon/helpers/reselectHelpers';
import {CardGroupsTableColumnsEnum} from './cardGroupsTableConfig';
import {CardGroupsTableRow} from './cardGroupsTableRow';

/*
 * Props.
 */

interface CardGroupsTableRowContainerPublicProps {
  cardGroupId: number;
  tableColumns: ReadonlyArray<TableColumn<CardGroupsTableColumnsEnum>>;
  options: TableRowRenderOptions;
}

/*
 * Selectors.
 */

function getCardGroupId(_state: AppState, props: CardGroupsTableRowContainerPublicProps) {
  return props.cardGroupId;
}

function makeGetCardGroup() {
  return createSelector(
    [getCardGroupId, getCardGroups],
    (cardGroupId, cardGroups) => cardGroups[cardGroupId],
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CardGroupsTableRowContainerPublicProps>()(() => {
  const getCardGroup = makeGetCardGroup();
  return {
    cardGroup: getCardGroup,
  };
});

export const CardGroupsTableRowContainer = connect(mapStateToProps)(CardGroupsTableRow);
